module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/beijing.14d394e3.mp3";